// Navigation links data structure
export interface NavLink {
  text: string;
  href: string;
}

export interface DropdownItem {
  text: string;
  href: string;
}

export interface DropdownMenu {
  id: string;
  triggerText: string;
  items: DropdownItem[];
  isWide?: boolean;
}

export interface DesignSystemNavGroup {
  id: string;
  items: DropdownItem[];
}

/** @deprecated Use DesignSystemNavGroup */
export type UiKitNavGroup = DesignSystemNavGroup;

// Simple navigation links
export const navLinks: NavLink[] = [
  { text: 'About', href: '/about' },
  { text: 'Process', href: '/' },
  { text: 'Style Guide', href: '/style-guide' },
];

// Regular dropdown menu items
export const regularDropdownItems: DropdownItem[] = [
  { text: 'Forms', href: '#forms' },
  { text: 'Tabs', href: '#tabs' },
  { text: 'FAQ', href: '#faq' },
  { text: 'Tabs', href: '#tabs' },
  { text: 'Carousel', href: '#carousel' },
  { text: 'Accordion', href: '#accordion' },
  { text: 'Collapsible', href: '#collapsible' },
];

// Base path for UI Kit section links
export const DESIGN_SYSTEM_BASE_PATH = '/design-system/';

/** @deprecated Use DESIGN_SYSTEM_BASE_PATH */
export const UI_KIT_BASE_PATH = DESIGN_SYSTEM_BASE_PATH;

/**
 * Design system page nav: grouped by intent. `wideDropdownItemsRaw` is flattened
 * for demos (e.g. combobox) that need a simple list.
 */
export const wideDropdownGroupsRaw: DesignSystemNavGroup[] = [
  {
    id: 'overview',
    items: [
      { text: 'Intro', href: '#design-system-hero' },
      { text: 'System overview', href: '#design-system-overview' },
      { text: 'Spacing & radius', href: '#foundations-tokens' },
    ],
  },
  {
    id: 'workflow',
    items: [
      { text: 'Product workflow', href: '#group-workflow' },
      { text: 'Stepper', href: '#stepper' },
    ],
  },
  {
    id: 'layout',
    items: [
      { text: 'Grid', href: '#grid' },
    ],
  },
  {
    id: 'actions',
    items: [
      { text: 'Buttons', href: '#buttons' },
      { text: 'Loaders', href: '#loaders' },
      { text: 'CTA Band', href: '#cta-band' },
    ],
  },
  {
    id: 'forms',
    items: [
      { text: 'Forms', href: '#forms' },
      { text: 'Inline validation', href: '#inline-form-validation' },
      { text: 'Async validation', href: '#async-inline-validation' },
      { text: 'Tag chips (typeahead)', href: '#search-chips' },
      { text: 'Contact pattern', href: '#contact-flow-pattern' },
    ],
  },
  {
    id: 'forms_advanced',
    items: [
      { text: 'Combo Box', href: '#combo-box' },
      { text: 'File Uploader', href: '#uploader' },
      { text: 'Image Uploader', href: '#uploader-image' },
      { text: 'Meter / Score', href: '#meter' },
      { text: 'Date Range Picker', href: '#date-range-picker' },
      { text: 'Date Picker', href: '#date-picker' },
      { text: 'Date Input (Popover)', href: '#date-input-popover' },
    ],
  },
  {
    id: 'navigation',
    items: [
      { text: 'Breadcrumbs', href: '#breadcrumbs' },
      { text: 'Pagination', href: '#pagination' },
      { text: 'Command Palette', href: '#cmdk' },
      { text: 'Search Suggest', href: '#search-suggest' },
      { text: 'Multi-step modal', href: '#multi-step-modal-wizard' },
    ],
  },
  {
    id: 'data',
    items: [
      { text: 'Toasts', href: '#toasts' },
      { text: 'Tooltips', href: '#tooltips' },
      { text: 'Modals', href: '#modals' },
      { text: 'Empty & error', href: '#empty-states' },
      { text: 'Dashboard pattern', href: '#data-dashboard-pattern' },
      { text: 'Cards', href: '#cards' },
      { text: 'Data Table', href: '#data-table' },
      { text: 'Metric Cards', href: '#metric-cards' },
      { text: 'Timeline', href: '#timeline' },
      { text: 'Filters', href: '#filters' },
      { text: 'Logic Pills', href: '#logic-pills' },
    ],
  },
  {
    id: 'media',
    items: [
      { text: 'Logo rotator', href: '#logo-rotator' },
      { text: 'Carousel', href: '#carousel' },
      { text: 'Image Slider', href: '#image-slider' },
      { text: 'Image Rotator', href: '#image-rotator' },
    ],
  },
  {
    id: 'principles',
    items: [
      { text: 'System principles', href: '#design-system-principles' },
      { text: 'Closing', href: '#group-closing' },
    ],
  },
  {
    id: 'disclosure',
    items: [
      { text: 'Tabs', href: '#tabs' },
      { text: 'Accordion', href: '#accordion' },
      { text: 'Collapsible', href: '#collapsible' },
    ],
  },
];

export const wideDropdownItemsRaw: DropdownItem[] = wideDropdownGroupsRaw.flatMap((g) => g.items);

export const wideDropdownItems: DropdownItem[] = wideDropdownItemsRaw.map((item) => ({
  ...item,
  href: `${DESIGN_SYSTEM_BASE_PATH}${item.href}`,
}));

// All dropdown menus
export const dropdownMenus: DropdownMenu[] = [
  {
    id: 'uiKit',
    triggerText: 'UI Kit',
    items: regularDropdownItems,
    isWide: false,
  },
  {
    id: 'uiKit2',
    triggerText: 'Design system',
    items: wideDropdownItems,
    isWide: true,
  },
];
